import { render, staticRenderFns } from "./ParentComment.vue?vue&type=template&id=8bb01818"
import script from "./ParentComment.vue?vue&type=script&lang=js"
export * from "./ParentComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports